import { Box, Typography } from "@mui/material";
import { JobDetailViewModel } from "./jobDetailTypes";
import { DetailCard, DetailField } from "./DetailCard";

type Props = {
  job: JobDetailViewModel;
};

export default function TimeTrackingCard({ job }: Props) {
  return (
    <DetailCard title="Time Tracking">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <DetailField
          label="Days From Today"
          value={
            <Typography component="span" sx={{ fontSize: 22, fontWeight: 700, color: "#2E7D32" }}>
              {job.daysFromToday ?? "—"}
            </Typography>
          }
        />
        <DetailField
          label="Days Since Received"
          value={
            <Typography component="span" sx={{ fontSize: 22, fontWeight: 700, color: "text.primary" }}>
              {job.daysSinceReceived ?? "—"}
            </Typography>
          }
        />
      </Box>
    </DetailCard>
  );
}
